import { businessKey } from 'queryKeys';

const MUTATION_MARK_AS_READ = 'markAsRead';

export const CONVERSION_GROUPS = 'conversion-groups';

export const conversionGroupsQuery = businessKey.query(CONVERSION_GROUPS);

export const conversionGroupsDetails = conversionGroupsQuery.details();

export const conversionGroupsGrids = conversionGroupsQuery.grids();
export const conversionGroupsGrid = conversionGroupsQuery.grid();

export const mutations = conversionGroupsQuery.mutations();

export const markAsRead = mutations.mutate(MUTATION_MARK_AS_READ);
